<template>
  <div :style="cssProps">
    <div class="rl__filters-container" v-if="!isMobile()">
      <div class="rl__filters" v-if="selectedValues">
        <ul>
          <li class="rl__filters-solution" v-for="(item, index) in menu" v-bind:key="item.id">
            <a @click="toggleMenu(index)" :class="{ isActive: currentSelected == index }">
              {{ item.label }}
              <span class="rl__filter-count" v-if="getSelectedMenuLength(item.id) > 0">({{ getSelectedMenuLength(item.id) }})</span>
              <span class="ico-ctx-caret-down" :class="{ filterOpen: currentSelected == index }"></span>
            </a>
          </li>    
        </ul>
        <slot></slot>
      </div>
      <div class="rl__filterBody-container">
        <div class="filterBody" v-for="(menuItem, index) in menu" v-bind:key="menuItem.id" :class="{ hideMenu: currentSelected !== index }">
          <div class="rl__filters-item" key="clear" @click="onSelectionChange(menuItem.id, { label: 'clear' })">
            <span :class="[getSelectedMenuLength(menuItem.id) > 0 ? 'rl__clear-filter' : 'rl__filter-hidden']" >{{$t('clearAllSelected')}}</span>
          </div>
          <ul role="menubar" :class="menuItem.class">
            <li role="menuitemcheckbox">
              <div class="rl__filters-item" key="all" @click="onSelectionChange(menuItem.id, { label: 'all' })">
                <span :class="[selectedValues[menuItem.id] && selectedValues[menuItem.id].length === menuItem.items.length? 'isCheckActive filterCheck': 'filterCheck']">
                   {{ menuItem.allFilterLabel }}</span>
              </div>
            </li>
            <li role="menuitemcheckbox" v-for="item in menuItem.items" v-bind:key="item.id">
              <div class="rl__filters-item" @click="onSelectionChange(menuItem.id, item)">
                <span :class="[isSelected(menuItem.id, item) ? 'isCheckActive filterCheck': 'filterCheck']">{{ item.name }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="rl__mobile_filter-menu" v-else>
      <Accordion :onClick="setActiveItem" :isSelected="isExpanded">
        <template v-slot:title>{{$t('filterLabel')}}</template>
        <slot></slot>
        <template v-slot:sub-title>
          <div class="rl__mobile_view-info" v-if="isFilterApplied && !isExpanded">
            {{$t('filteredRes')}}
          </div>
        </template>
        <template v-slot:body>
          <div class="rl__mobile_filter-header">
            <div>{{$t('filterRes')}}</div>
            <div class="rl__mobile_filter-cta">
              <div :class="[showClearAll ? 'rl__clear_all-show' : 'rl__clear_all-hide']" @click="clearAll()">{{$t('clearAllCta')}}</div>
              <div @click="closeFilter()" class="ctx-button primary ctx-blue ctx-medium-btn">{{$t('applyCta')}}</div>
            </div>
          </div>
          <Accordion v-for="(item, index) in menu" v-bind:key="item.id" :onClick="() => setActiveIndex(index + 1)" :isSelected="isSelectedIndex(index + 1)">
            <template v-slot:title><div class="rl__card_type">{{ item.label.toUpperCase() }}</div>
              <span class="rl__filter-count" v-if="getSelectedMenuLength(item.label) > 0">({{ getSelectedMenuLength(item.label) }})</span>
            </template>
            <template v-slot:body>
              <div class="filterBody">
                <ul role="menubar">
                  <li role="menuitemcheckbox">
                    <div class="rl__filters-item rl__filters_clear-all" key="clear" @click="onSelectionChange(menu[index].id, { label: 'clear' })">
                      <span v-if="getSelectedMenuLength(menu[index].id) > 0 "  class="rl__clear-filter" >{{$t('clearAllSelected')}}</span>
                    </div>
                  </li>
                  <li role="menuitemcheckbox">
                    <div class="rl__filters-item" key="all" @click="onSelectionChange(menu[index].id, { label: 'all' })">
                      <span :class="[selectedValues[menu[index].id] && selectedValues[menu[index].id].length ===menu[index].items.length? 'isCheckActive filterCheck filterChecked': 'filterCheck']">
                        {{ menu[index].allFilterLabel }}
                      </span>
                    </div>
                  </li>
                  <li role="menuitemcheckbox" v-for="item in menu[index].items" v-bind:key="item.id">
                    <div class="rl__filters-item" @click="onSelectionChange(menu[index].id, item)">
                      <span :class="[isSelected(menu[index].id, item)? 'isCheckActive filterCheck filterChecked': 'filterCheck']">
                        {{ item.name }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div> 
            </template>    
          </Accordion>
          <div @click="toggleEnglish()" v-if="showCheckbox" :class="[ isChecked ? 'isCheckActive filterCheck' : 'filterCheck' ]"> {{$t('includeEnglishRes')}}</div>
        </template>
      </Accordion>
    </div>
  </div>
</template>


<script>
import translations from "../translations";
import commonMixins from "../mixins/common";
import Accordion from "./Accordion.vue";

export default {
  name: "Filters",
  mixins: [commonMixins],
  components: {
    Accordion,
  },
  data() {
    return {
      currentSelected: -1,
      menu: [],
      currentItem: -1,
      isExpanded: false,
      filterObj: window.CTX_RL.filter_data,
      themeColor: window.CTX_RL.theme_color || "#05758a",
      hoverColor: window.CTX_RL.hover_color || "#1c9cad"
    };
  },

  props: {
    selectedValues: {
      default: {},
    },
    isFilterApplied: Boolean,
    isChecked: Boolean,
    toggleEnglish: Function,
    showCheckbox: Boolean,
    showClearAll: Boolean
  },

  computed: {
    cssProps() {
      return {
        '--theme-color' : this.themeColor,
        '--hover-color' : this.hoverColor
      }
    }
  }, 

  methods: {
    toggleMenu(index) {
      if (this.currentSelected !== index) this.currentSelected = index;
      else this.currentSelected = -1;
    },

    getSelectedMenuLength(label) {
      return this.selectedValues[label] && this.selectedValues[label].length;
    },
  
    onSelectionChange(label, item) {
      const selectedFilters = { ...this.selectedValues };
      const { id: itemId, label: filterLabel } = item;
      if (filterLabel !== "all" && filterLabel !== "clear") {
        const currentIndex = selectedFilters && selectedFilters[label] && selectedFilters[label].findIndex(({ id }) => itemId === id);
        const labelItems = selectedFilters[label] || [];
        if (currentIndex > -1) {
          labelItems.splice(currentIndex, 1);
          selectedFilters[label] = labelItems;
        } else selectedFilters[label] = [...labelItems, item];
      } else {
        const { items } = this.menu.find((menuitem) => menuitem["id"] === label);
        if ((selectedFilters[label] && selectedFilters[label].length === items.length) || item.label == "clear")
          selectedFilters[label] = [];
        else selectedFilters[label] = [...items];
      }
      this.$emit("updateData", selectedFilters);
    },

    isSelected(label, item) {
      return (
        this.selectedValues && this.selectedValues[label] && this.selectedValues[label].some((menuItem) => menuItem.id == item.id)
      );
    },

    setActiveItem() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) document.querySelector(".rl__mobile_view-body").classList.add("hide");
      else document.querySelector(".rl__mobile_view-body").classList.remove("hide"); 
    },

    setActiveIndex(index) {
      if (this.currentItem == index) this.currentItem = -1;
      else this.currentItem = index;
    },

    closeFilter() {
    this.currentItem = -1;
      this.isExpanded = false;
      document.querySelector(".rl__mobile_view-body").classList.remove("hide");
    },

    isSelectedIndex(index) {
      return this.currentItem === index;
    },

    clearAll() {
      Object.keys(this.selectedValues).map((key) => (this.selectedValues[key] = []));
    },

    getTranslations() {
      return translations[this.$i18n.locale] || translations["en-us"];
    },

    populateMenuData() {
      const  localeData = Object.keys(this.filterObj).length > 0 ? this.filterObj.filterData: this.getTranslations().filterData;
      Object.keys(localeData).forEach((menuItem) => {
        this.menu.push({
          id: menuItem,
          label: localeData[menuItem].label,
          items: localeData[menuItem].items,
          allFilterLabel: localeData[menuItem].allFilterLabel,
        });
      });
  },
    close(e) {
      if (!this.$el.contains(e.target) && !e.target.classList.contains("rl__clear-filter")) this.currentSelected = -1;
    },
  },

  mounted() {
    document.addEventListener("click", this.close);
     //extract filter  values from the url
     window.addEventListener('load', () => {
    const  localeData = Object.keys(this.filterObj).length > 0 ? this.filterObj.filterData: this.getTranslations().filterData;
    const queryString = location.href.includes('author') ? decodeURI(location.href).split('/?') : decodeURI(location.href).split('?');
    if(queryString.length > 1) {
      const queryvalues = {};
      const nameValues = queryString[1].split('&');
      nameValues.forEach(queryParam => queryvalues[queryParam.split('=')[0]] = queryParam.split('=')[1]);
      Object.keys(localeData).forEach(filterType => {
        const filterValue = queryvalues[filterType];
        if(filterValue) {
          const values = filterValue.split(',');
        this.selectedValues[filterType] = [];
        const itemsData = localeData[filterType];
          itemsData.items.forEach(item => {
            if(values.indexOf(item.name) > -1){
              this.selectedValues[filterType].push(item);
            }
          });
        }
      });
   
        setTimeout(() => {
        this.$emit("updateData", this.selectedValues);
      }, 500);
    
    }
});

  },

  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },

  created() {
    this.populateMenuData();
  },
};
</script>

<style  lang="scss">
@import "../css/_global.scss";
@import "../css/components/card.scss";

 .rl__filter-hidden {
    display: none;
  }
  .rl__filters_clear-all {
    margin: 10px 0;
  }

  .rl__clear_all-show {
    opacity: 1;
  }
   .rl__clear_all-hide {
    opacity: 0;
  }
  .rl__filters-solution > a{
    font-size: 1rem;
  }
.rl__filters-container {
  .rl__filters {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .ico-ctx-caret-down {
    font-size: 12px;
    font-weight: bold;
    color: $ctx-gray-50;
    display: inline-block;
    transition: rotate 500ms;
    @include prefix(transition, transform 250ms ease);
  }

  .rl__filters ul > li {
    padding-right: 20px;
    display: inline-block;
    border: 0;
    cursor: pointer;
    > a {
      color: var(--theme-color) !important;
      &.isActive {
        color: var(--hover-color) !important;
        border-bottom: 3px solid var(--theme-color) !important;
      }
      &:active,
      &:focus {
        border-bottom-color: transparent;
      }
      &:hover {
        border-bottom-color: transparent;
        color: var(--hover-color) !important;
      }
    }
  }

  .rl__filterBody-container {
    position: absolute;
  }

  .rl__filter-count {
    padding-right: 5px;
  }
  .filterBody {
    transform: translateX(12%);
    opacity: 1;
    transition: opacity 0.2s, visibility 0.2s;
    font-size: 15px;
    z-index: 99992;
    position: absolute;
    top: 5px;
    width: 1000px;
    height: auto;
    padding: 15px;
    border: 1px solid #ccc;
    background-color: #fff;
    @include prefix(box-shadow, 0px 0px 5px 2px rgba(0, 0, 0, 0.18));

    &:first-child ul {
      column-count: 2;
    }
    &:not(:first-child) ul {
      column-count: 3;
    }
    >.rl__filters-item {
      padding-bottom: 10px;
    }
  }
  .rl__clear-filter {
    color: var(--theme-color);
    transition: opacity 0.5s ease;  
    cursor: pointer;
    &:hover {
      color: var(--hover-color);
    }
  }
  .hideMenu {
    visibility: hidden;
    opacity: 0;
  }
  .filterOpen {
    transform: rotate(180deg);
  }

  .rl__filters > .filterCheck {
    line-height: 19px;
  }
}

//mobile styles

.rl__mobile_filter > div>.rl__accordion > .rl__accordion-title,
.rl__mobile_filter-header .rl__card_type,
.rl__mobile_filter-cta div:first-child,
.rl__mobile_filter-menu > .rl__accordion > .rl__accordion-body .rl__accordion .rl__accordion-title,
.filterChecked,
.rl__mobile_filter-menu .rl__filters_clear-all > .rl__clear-filter{
   color: var(--theme-color);
  }

  .rl__mobile_filter > div > .rl__accordion > .rl__accordion-body {
    border-top: 3px solid var(--hover-color);
  }
</style>

